exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable tr th[data-v-273155f1] {\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n}\ntable tr td[data-v-273155f1] {\n  padding: 0 1rem;\n}\n.slightlySmallerText[data-v-273155f1] {\n  font-size: 0.9rem;\n}\n.floating-menu[data-v-273155f1] {\n  padding: 3px;\n  border: 1px solid #8ca0b324;\n}\n.startHourWidth[data-v-273155f1] {\n  width: 12%;\n}\n.notesWidth[data-v-273155f1] {\n  width: 30%;\n}\n.btn-size[data-v-273155f1] {\n  width: 130px;\n  height: 39px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-273155f1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Availability/SingleDay.vue
// module id = 2780
// module chunks = 0